module.exports = __webpack_public_path__ + "img/logo-AI-kasa-negativ.633ca39d.png";